<template>
  <!-- 头部整体盒子 -->
  <div id="header" class="container-fuild">
    <!-- 头部顶部 -->
    <div class="header-top container-fuild hidden-xs">
      <div class="container">
        <div class="server pull-left">
          <span class="glyphicon glyphicon-earphone"></span>13923711287
          <span class="glyphicon glyphicon-envelope"></span>9311914@qq.com
          <span class="glyphicon glyphicon-time"></span>7x24小时为您服务打
        </div>
        <div class="shejiao pull-right">
          <span class="glyphicon glyphicon-hand-right"></span>为您量身定制，赶快联系我们吧！
          <!-- <span class="lang" @click="changelan">{{langs[$i18n.locale]}}</span> -->
        </div>
      </div>
    </div>
    <!-- 电脑导航 -->
    <div class="header-nav container hidden-xs">
      <!-- 导航logo -->
      <div class="header-nav-logo">
        <!-- <img src="@/assets/img/logo_black.png"> -->
        <!-- <img src="@/assets/img/logo1.png" class="logo"> -->
        <img src="@/assets/img/logo1.png" class="logo">
      </div>
      <!-- 导航内容 -->
      <ul class="header-nav-wrapper">
        <li
          v-for="(item,index) in navList"
          :key="index"
          :class="index==navIndex?'active':''"
          @click="navClick(index,item.name)"
        >
          <router-link :to="item.path">
            <!-- {{item.name}} -->
            {{$i18n.locale=='CN'?item.name:item.enname}}
            <span v-if="item.children.length>0" class="glyphicon glyphicon-menu-down"></span>
            <i class="underline"></i>
          </router-link>
          <dl v-if="item.children.length>0">
            <dt v-for="(i,n) in item.children" :key="n">
              <router-link :to="i.path">{{i.name}}</router-link>
            </dt>
          </dl>
        </li>
      </ul>
    </div>
    <!-- 手机导航 -->
    <div class="header-nav-m container-fuild visible-xs">
      <div class="header-nav-m-logo">
        <!-- <img class="center-block" src="@/assets/img/logo1.png" alt="logo"> -->
        <img class="center-block" :src="info.company?host+info.company.logo:''" alt="logo">
        <!-- <span class="langmb" @click="changelan">{{langs[$i18n.locale]}}</span> -->
      </div>
      <!-- 导航栏 -->
      <div class="header-nav-m-menu text-center">
        {{menuName}}
        <div
          class="header-nav-m-menu-wrapper"
          data-toggle="collapse"
          data-target="#menu"
          @click="menuClick"
        >
          <span :class="menuClass"></span>
        </div>
        <!-- 导航内容 -->
        <ul id="menu" class="header-nav-m-wrapper collapse">
          <li
            v-for="(item,index) in navList"
            :key="index"
            :class="index==navIndex?'active':''"
            @click="navClick(index,item.name,item.enname)"
            data-toggle="collapse"
            data-target="#menu"
          >
            <router-link :to="item.path">
              <!-- {{item.name}} -->
              {{$i18n.locale=='CN'?item.name:item.enname}}
              <i class="underline"></i>
            </router-link>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import get from '../api/get'
export default {
  name: "Header",
  data() {
    return {
      location: window.location,
      langs:{
        EN:"简体中文",
        CN:'English'
      },
      host:'',
      info:{},
      navIndex: sessionStorage.getItem('navIndex') ? sessionStorage.getItem('navIndex') : 0,
      menuName: localStorage.localeLanguage=='CN'?'首页':'Home',
      menuClass: "glyphicon glyphicon-menu-down",
      navList: [
        {
          name: "风道物联",
          enname:'Home',
          path: "/",
          children: [],
          id:1
        },
        {
          name: "解决方案",
          enname:'Solution',
          path: "/software",
          children: [
            // {
            //   name: "风道物联宿管系统",
            //   path: "/software/smartTown"
            // },
            // {
            //   name: "风道物联民宿系统",
            //   path: "/software/bigData"
            // }
          ],
          id:2
        },
        {
          name: "相关服务",
          enname:'Services',
          path: "/service",
          children: [],
          id:3
        },
        {
          name: "新闻动态",
          enname:'News',
          path: "/newsinformation",
          children: []
        },
        {
          name: "公司介绍",
          enname:'Company',
          path: "/companyintroduction",
          children: [],
          id:4
        },
        {
          name: "工作机会",
          enname:'Job chance',
          path: "/jobchance",
          children: [],
          id:5
        },
        {
          name: "联系我们",
          enname:'Contact us',
          path: "/contactus",
          children: [],
          id:6
        }
      ]
    };
  },
  methods: {
    navClick(index, name,enname) {
      this.navIndex = index;
      sessionStorage.setItem('navIndex',index)
      // console.log(localStorage.localeLanguage)
      if(localStorage.localeLanguage=='CN'){
        this.menuName = name;
      }else{
        this.menuName = enname;
      }

    },
    menuClick() {
      if (this.menuClass == "glyphicon glyphicon-menu-down") {
        this.menuClass = "glyphicon glyphicon-menu-up";
      } else {
        this.menuClass = "glyphicon glyphicon-menu-down";
      }
    },
    //更换语言
    changelan(){
      localStorage.localeLanguage = this.$i18n.locale === 'CN' ? 'EN' : 'CN'
      location.reload()
    }
  },
  // async created(){
  //   // console.log(this.$i18n)
  //   this.$i18n.locale = localStorage.localeLanguage || 'CN'
  //   this.host = this.url
  //   get('/api/configPublic',{
  //     lg:localStorage.localeLanguage
  //   }).then((res)=>{
  //     // console.log(res)
  //     if(res.data.code==200){
  //       this.info = res.data.data
  //       var data = JSON.stringify(res.data.data)
  //       sessionStorage.setItem('public',data)
  //     }else{
  //       alert('网络连接失败，请稍后重试')
  //     }
  //   })
  //   // var data = JSON.parse(sessionStorage.getItem('public'))
  //   // this.info = data
  //   // console.log(this.info)
  // },

};
</script>
<style scoped>
/* 顶部 */
.lang{
  width: 100px;
  display: inline-block;
  text-align: center;
  cursor: pointer;
}
.langmb{
  display: inline-block;
  text-align: center;
  cursor: pointer;
  position: absolute;
  right: 20px;
  top: 10px;
}
#header {
  background: #f4f4f4;
  transition: all ease 0.6s;
}
#header .header-top {
  height: 50px;
  color: #fff;
  font-size: 12px;
  line-height: 50px;
  background: #474747;
}
/* 顶部的图标 */
#header .header-top span {
  margin: 0 8px;
}
/* 导航栏 */
#header .header-nav {
  height: 110px;
}
/* 导航栏logo */
#header .header-nav .header-nav-logo {
  width: 100px;
  height: 100%;
  float: left;
  position: relative;
}
/* 导航栏logo图片 */
#header .header-nav .header-nav-logo img {
  width: 135px;
  height: 65px;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
}
/* 导航栏 导航容器 */
#header .header-nav-fixed .header-nav-wrapper {
  line-height: 50px;
}
#header .header-nav .header-nav-wrapper {
  line-height: 110px;
  float: right;
  margin: 0;
  max-width: 800px;
}
/* 导航栏 每个导航 */
#header .header-nav .header-nav-wrapper > li {
  float: left;
  margin: 0 15px;
  position: relative;
}
/* 导航栏 每个导航下面的 a 链接 */
#header .header-nav .header-nav-wrapper > li > a {
  color: #000;
  font-size: 15px;
  font-weight: bold;
  padding: 15px 0;
  position: relative;
}
/* 导航栏 每个导航下面的 a 链接的下划线 */
#header .header-nav .header-nav-wrapper > li > a > i {
  display: block;
  position: absolute;
  bottom: -2px;
  left: 50%;
  width: 0;
  height: 2px;
  opacity: 0;
  transition: all 0.6s ease;
  background-color: #1e73be;
}
/* 导航栏 每个导航下面的 a 链接的右侧小三角 */
#header .header-nav .header-nav-wrapper > li > a > span {
  font-size: 12px;
  transition: transform ease 0.5s;
}
/* 导航栏 每个导航下面的 a 链接 鼠标滑上去的样式 */
#header .header-nav .header-nav-wrapper > li > a:hover {
  color: #1e73be;
  text-decoration: none;
}
/* 导航栏 每个导航下面的 a 链接 鼠标滑上去下划线的样式 */
#header .header-nav .header-nav-wrapper > li > a:hover .underline {
  opacity: 1;
  width: 100%;
  left: 0;
}
/* 导航栏 每个导航下面的 a 链接 鼠标滑上去三角标的样式 */
#header .header-nav .header-nav-wrapper > li > a:hover span {
  transform: rotate(180deg);
}
/* 导航栏 每个导航下面的 a 链接 鼠标点击后的样式 */
#header .header-nav .header-nav-wrapper > li.active > a {
  /* color: #1e73be; */
  text-decoration: none;
  /* border-bottom: 2px solid #1e73be; */
}
/* 导航栏 每个导航下面的二级导航容器 */
#header .header-nav .header-nav-wrapper > li > dl {
  display: none;
  position: absolute;
  width: 168px;
  top: 80%;
  left: 0;
  z-index: 999999;
  box-shadow: 0 0 3px 1px #ccc;
  background: #fff;
}
/* 导航栏 每个导航下面的二级导航容器的每个导航 */
#header .header-nav .header-nav-wrapper > li > dl > dt {
  width: 100%;
  padding: 10px;
  border-bottom: 1px solid #ccc;
}
/* 导航栏 每个导航下面的二级导航容器的每个导航 当鼠标滑上时的样式*/
#header .header-nav .header-nav-wrapper > li > dl > dt > a:hover {
  text-decoration: none;
}
/* 导航栏 滑上一级导航显示二级导航 */
#header .header-nav .header-nav-wrapper > li:hover dl {
  display: block;
}
#header .header-nav .header-nav-wrapper > li > dl > dt:hover {
  cursor: pointer;
  background: #ccc;
}
.logo{
  width: 110px;
  height: 55px;
}
@media screen and (max-width: 997px) {
  #header .header-nav-m {
    position: relative;
  }
  /* 导航栏logo容器 */
  #header .header-nav-m .header-nav-m-logo {
    height: 80px;
    position: relative;
  }
  /* 导航栏logo图片 */
  #header .header-nav-m .header-nav-m-logo img {
    width: 95px;
    height: 45px;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
  }
  /* 导航栏  菜单容器 */
  #header .header-nav-m .header-nav-m-menu {
    color: #fff;
    height: 50px;
    font-size: 20px;
    line-height: 50px;
    background: #474747;
    position: relative;
  }
  /* 导航栏 菜单图标 */
  #header .header-nav-m .header-nav-m-menu-wrapper {
    position: absolute;
    top: 50%;
    right: 20px;
    margin-top: -20px;
    width: 50px;
    height: 40px;
    color: #fff;
    z-index: 999999;
    font-size: 12px;
  }
  /* 导航栏 */
  #header .header-nav-m .header-nav-m-wrapper {
    position: absolute;
    top: 50px;
    left: 0;
    width: 100%;
    background: #474747;
    z-index: 9999999;
  }
  /* 导航栏 每个导航 */
  #header .header-nav-m .header-nav-m-wrapper > li {
    height: 40px;
    line-height: 40px;
    border-bottom: 1px solid #ccc;
  }
  /* 导航栏 每个导航下面的 a 链接 */
  #header .header-nav-m .header-nav-m-wrapper > li > a {
    color: #fff;
    font-size: 15px;
    font-weight: bold;
    padding: 15px 0;
    position: relative;
  }
  /* 导航栏 每个导航下面的 a 链接的右侧小三角 */
  #header .header-nav .header-nav-wrapper > li > a > span {
    font-size: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue